export default class SportApp {
    /**
     * Initialise the page
     *
     * @return {void}
     */
    init () {
        this.expanders = document.querySelectorAll('.js-pn-sport-app-expander');
        this.bindEventListeners();
        this.handleConfirmCheckbox();
    }

    /**
     * Bind event listeners
     *
     * @return {void}
     */
    bindEventListeners () {
        [...this.expanders].forEach(expander => {
            expander
                .querySelector('.js-pn-sport-app-expander__toggle')
                .addEventListener('click', () => {
                    this.toggleExpander(expander);
                });
        });
    }

    /**
     * Take an array of elements and order them based on top and left position
     *
     * @param  {Object} expander  the expander dom element to toggle
     * @return {void}  the sorted array
     */
    toggleExpander (expander) {
        const toggle = expander.querySelector(
            '.js-pn-sport-app-expander__toggle'
        );

        const content = expander.querySelector(
            '.js-pn-sport-app-expander__content'
        );

        expander.classList.toggle('is_expanded');

        const isExpanded = expander.classList.contains('is_expanded');

        toggle.setAttribute('aria-expanded', isExpanded);
        content.setAttribute('aria-hidden', !isExpanded);
    }

    /**
     * Enable/disable submit button when terms checkbox is clicked
     *
     * @return {void}  the sorted array
     */
    handleConfirmCheckbox () {
        const confirmCheckbox = document.querySelector('.js-pn-sport-app-form__checkbox');
        const submitButton = document.querySelector('.js-pn-sport-app-form__submit');

        confirmCheckbox.addEventListener('change', () => {
            submitButton.disabled = (confirmCheckbox.checked === false);
        });
    }
}
